import { PropTypes } from 'prop-types';
import Preload from 'react-preload';
import OneBackTests from './tests';

const imagesToUrls = (images) => {
  let urls = [];
  for (var image of images) {
    urls.push(require(`../../../images/tasks/oneback/${image}.jpg`));
  }

  return urls;
};

const loadingIndicator = <div>Loading...</div>;

const OneBackPresenter = (props) => (
  <Preload
    loadingIndicator={loadingIndicator}
    images={imagesToUrls(props.tests)}
  >
    {
      <OneBackTests
        onStart={props.testIndex == 0 ? props.onStart : null}
        timeToHit={props.timeToHit}
        onTimeout={props.onTimeout}
        onHit={props.onHit}
        key={props.tests[props.testIndex]}
        image={props.tests[props.testIndex]}
      />
    }
  </Preload>
);

export default OneBackPresenter;

OneBackPresenter.propTypes = {
  tests: PropTypes.arrayOf(PropTypes.string).isRequired,
  testIndex: PropTypes.number.isRequired,
  timeToHit: PropTypes.number.isRequired, // in centiseconds
  onTimeout: PropTypes.func.isRequired,
  onHit: PropTypes.func.isRequired,
  onStart: PropTypes.func,
};
